import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]

import {computed} from "vue";
    import {qrcode} from "../util/qrcode";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'QRCode',
  props: ['text', 'typeNumber', 'errorCorrectionLevel', 'alt'],
  setup(__props) {

    const props = __props

    const imgSrc = computed(() => {
        const code = qrcode(props.typeNumber || 0, props.errorCorrectionLevel || 'M')
        code.addData(props.text)
        code.make()
        return code.createDataURL(4 )
    })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: imgSrc.value,
    alt: __props.alt
  }, null, 8 /* PROPS */, _hoisted_1))
}
}

})